import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'Home',
    component: Home
  }, {
    path: '/product',
    name: 'Product',
    component: () => import('../views/Product.vue')
  }, {
    path: '/detail/:index',
    name: 'Detail',
    component: () => import('../views/Detail.vue'),
    props: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
